import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Roulette from './Pages/Roulette';
import Splash from './Pages/Splash';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          exact
          path='/games/BVD/default/bovada-roulette/roulette/*'
          element={<Roulette />}
        />
        <Route
          exact
          path='/games/BVD/default/bovada-roulette/roulette'
          element={<Roulette />}
        />
        <Route path='/*' element={<Splash />}></Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
